export const GET_TABLE_META_DATA_LIST = 'GET_TABLE_META_DATA_LIST';
export const SET_TABLE_CONFIG_LIST = 'SET_TABLE_CONFIG_LIST';
export const SAVE_TABLE_CONFIG = 'SAVE_TABLE_CONFIG';
